import moment from 'moment';
import { isEmpty, isUndefined, isNull } from 'lodash';

const isLoaded = value => !isUndefined(value) && !isNull(value);

export const getTimeOptions = () => {
  const initialDate = moment().startOf('day'); // Start at midnight
  const totalIterations = 12 * 24; // 12 blocks of 5 minutes per hour times 24 hours in a day
  const timeOptions = [];
  for ( let i = 0; i < totalIterations; i++ ) {
    const date = initialDate.clone().add(5 * i, "minutes");
    const value = date.format("h:mm a");
    timeOptions.push({
      value,
      label: value,
      date, // Used to compute duration
      order: i // Used to filter valid dates
    })
  }
  return timeOptions;
}

export const repeatOptions = [
  { label: "Does not repeat", value: false },
  { label: "Weekly", value: true }
];

export const getTitleErrorMessage = title => {
  if ( title === "" ) return "Title is required";
  if ( title.length > 50 ) return "The maximum length for this field is 50"
  return "";
}

export const getDateErrorMessage = date => moment(date).isValid()
  ? "" 
  : "Date is invalid";

export const getCategoryErrorMessage = (categories, category) => 
  isLoaded(categories) && categories.length > 0 && isEmpty(category)
    ? "Category is required" 
    : "";

export const getCalendarErrorMessage = (calendars, calendar) => 
  isLoaded(calendars) && calendars.length > 0 && isEmpty(calendar)
    ? "Calendar is required" 
    : "";

export const getTimeErrorMessage = time => isEmpty(time) ? "Time is required" : "";

export const isFormValid = (
  title, 
  startDate, 
  repeat, 
  endDate, 
  categories, 
  category,
  calendars,
  calendar,
  startTime,
  endTime,
  isEdit
) => (
  // The following checks need to always be there
  isEmpty(getTitleErrorMessage(title)) && 
  isEmpty(getDateErrorMessage(startDate)) &&
  isEmpty(getTimeErrorMessage(startTime)) &&
  isEmpty(getTimeErrorMessage(endTime)) &&
  isEmpty(getCategoryErrorMessage(categories, category)) &&
  // The following don't apply when user is editing a reserve time
  (isEdit || (repeat.value === false || isEmpty(getDateErrorMessage(endDate)))) &&
  (isEdit || isEmpty(getCalendarErrorMessage(calendars, calendar)))
);
